import { connect } from 'react-redux';
import PropertySwitch from './modern/PropertySwitch';
import PropertyPicker from './modern/PropertyPicker';
import BaseFeature from './BaseFeature';
import FeatureCard from './components/FeatureCard';
import { cn } from 'lib/utils';
import { LAMP_OPERATING_TIME } from '../../../../../../utils/constantFeatures';
import { getErrorIssues, getWarningIssues } from '../../../../../../utils/validationSummary';

class OperatingTime extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[LAMP_OPERATING_TIME.enable].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === LAMP_OPERATING_TIME.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    // Same error/warning signal as BaseFeature.getClassName, minus the legacy
    // .card-feature-component base class — that one is `width: fit-content` and would
    // beat the modern card's `w-full` (both single-class specificity, and
    // stylesheet.css loads after Tailwind).
    cardState(properties) {
        if (getErrorIssues(this.props.issues, properties).length > 0) return 'danger';
        if (getWarningIssues(this.props.issues, properties).length > 0) return 'warning';
        return '';
    }

    render() {

        const opsEn = this.props.properties[LAMP_OPERATING_TIME.enable];
        const opsTi = this.props.properties[LAMP_OPERATING_TIME.time];

        let classNameSwitch = opsEn.valueMeta.min === opsEn.valueMeta.max ? 'card-none' : '';

        return (
            // The card rendered full width in built output. Cause was not this page: the
            // minifier collapsed `.card-feature-component`'s `width: fit-content;
            // width: -moz-max-content` pair down to the invalid -moz value, so the card
            // fell back to `width: auto`. Fixed at source in stylesheet.css. A block-level
            // card like this one had nothing else holding its width in — pages that wrap
            // their card in `.flex-row` were never affected, because a flex item on the
            // main axis is content-sized regardless.
            //
            // The modern grid below sets the width explicitly, so this page no longer
            // depends on that CSS either way.
            //
            // bodyLayout="fields" puts label / control / unit on three shared grid tracks
            // that every FieldRow joins via `display: contents`, so the rows line up down
            // the card. That needs the modern property twins: the legacy ones render their
            // own Bootstrap Row/Col, which inside this grid would collapse into a single
            // cell and reintroduce the cramped col-sm-4/5/2 proportions.
            <div className="mx-auto w-full max-w-[1800px] px-4 pb-4">
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 xl:grid-cols-12">
                    <FeatureCard
                        variant="modern"
                        title={'Operating Time'}
                        bodyLayout="fields"
                        className={cn('lg:col-span-1 xl:col-span-3', this.cardState([opsEn, opsTi]))}>
                        <PropertySwitch
                            property={opsEn}
                            title={opsEn.info.displayName}
                            className={classNameSwitch}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            disabled={!this.state.isEnabled}
                            property={opsTi}
                            title={opsTi.info.displayName}
                            measureUnit={'kh'}
                            min={opsTi.valueMeta.min}
                            max={opsTi.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                    </FeatureCard>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OperatingTime);
